var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLayoutAdvanced3DPrimary = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 29,
  height: 18,
  viewBox: "0 0 29 18",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(1 1)",
  stroke: "currentColor",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 27,
  height: 16.2,
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.429 10.5H27V14a2 2 0 0 1-2 2h-9.571v-5.5ZM15.429 0H25a2 2 0 0 1 2 2v3.4H15.429V0Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.2 0H2a2 2 0 0 0-2 2v12.2a2 2 0 0 0 2 2h14.2V0Z",
  fill: "#263A71"
}))));
export { SvgLayoutAdvanced3DPrimary as ReactComponent };
export default __webpack_public_path__ + "assets/images/layout-advanced-3d-primary.svg";